import DOMPurify from 'dompurify'

/**
 * SafeHTML Component - Renders HTML content safely with XSS protection
 * Uses DOMPurify to sanitize HTML before rendering
 *
 * @param {string} html - The HTML content to render
 * @param {string} className - CSS classes to apply to the container
 * @param {string} tag - HTML tag to use for the container (default: 'div')
 */
export default function SafeHTML({ html, className = '', tag = 'div' }) {
  if (!html) return null

  // Configure DOMPurify
  const config = {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'a', 'blockquote', 'code', 'pre', 'span', 'div',
      'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td'
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel', 'class', 'id', 'src', 'alt', 'title',
      'width', 'height', 'style'
    ],
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'style', 'iframe', 'form', 'input', 'button'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover']
  }

  // Sanitize HTML
  const sanitizedHTML = DOMPurify.sanitize(html, config)

  // Create component dynamically
  const Tag = tag

  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  )
}
